module.exports = __webpack_public_path__ + "d3f3ff386a64ee195701ef8dc8dce111.svg";